import { render, staticRenderFns } from "./SelectActiveBusiness.vue?vue&type=template&id=54a6826b"
import script from "./SelectActiveBusiness.vue?vue&type=script&lang=js"
export * from "./SelectActiveBusiness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports